export default {
  name: 'quickAdd',
  component() {
    return (variantId) => ({
      variantId,
      quantity: 1,
      adding: false,
      
      get inCart() { return this.$store.cart.hasItem(this.variantId); },
      
      async add() {
        if (this.adding) return;
        
        try {
          this.adding = true;
          await this.$store.cart.add(this.variantId, this.quantity);
        } catch (error) {
          console.error('Failed to add to cart:', error);
        } finally {
          this.adding = false;
        }
      }
    });
  }
};